module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }